import { render, staticRenderFns } from "./AddFiliale.vue?vue&type=template&id=6ec8b1ae&scoped=true&"
import script from "./AddFiliale.vue?vue&type=script&lang=js&"
export * from "./AddFiliale.vue?vue&type=script&lang=js&"
import style0 from "./AddFiliale.vue?vue&type=style&index=0&id=6ec8b1ae&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec8b1ae",
  null
  
)

export default component.exports